import { Modal } from 'antd';
import type { CompareModalProps } from './comparisonResultTypes';
import styles from './ComparisonResult.module.scss';

const CompareModal = ({ record, envAName, envBName, onClose }: CompareModalProps) => (
  <Modal
    open={!!record}
    onCancel={onClose}
    footer={null}
    width="80vw"
    title={record?.configSubElementName
      ? `${record.configName} — ${record.configSubElementName}`
      : record?.configName}
    className={styles.compareModal}
    destroyOnHidden
  >
    {record && (
      <div className={styles.compareModalBody}>
        <div className={styles.comparePane}>
          <h3 className={styles.comparePaneTitle}>Value in {envAName}</h3>
          <pre className={styles.comparePaneContent}>{record.valueInA}</pre>
        </div>
        <div className={styles.compareDivider} />
        <div className={styles.comparePane}>
          <h3 className={styles.comparePaneTitle}>Value in {envBName}</h3>
          <pre className={styles.comparePaneContent}>{record.valueInB}</pre>
        </div>
      </div>
    )}
  </Modal>
);

export default CompareModal;
